module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hPQNF"))).then(() => parcelRequire('4NZdz'));